import React from 'react';
import styled from 'styled-components';
import Tooltip from '../../shared/Tooltip';
import { KPMGLogoutIcon } from '../../../assets/icons';
import { automationIds } from '../../../constants/automationIds';
import { useTranslation } from 'react-i18next';
import store from '../../../store';
import ModalIds from '../../../constants/modalIds';
const StyledKPMGLogoutIcon = styled(KPMGLogoutIcon) `
  cursor: pointer;
  float: right;
  width: 32px;
  height: 32px;
`;
const IconContainer = styled.div `
  height: 32px;
`;
const Logout = () => {
    const { t: translate } = useTranslation();
    const handleLogOut = () => {
        store.modal[ModalIds.LOGOUT_CONFIRM].openModal();
    };
    return (<Tooltip title={translate('HEADER.BUTTON.LOGOUT')}>
      <IconContainer onClick={handleLogOut} data-automation-id={automationIds.BUTTON.LOGOUT}>
        <StyledKPMGLogoutIcon />
      </IconContainer>
    </Tooltip>);
};
export default Logout;
